export default "__VITE_ASSET__CTLrNe6k__"